import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import {
	prefetchPageContext,
	StarterDashboardV2PageContextProvider,
	StarterDashboardV2PageNotificationManagerProvider,
} from 'src/app/pages/starterDashboardV2/pageContext';
import type { StarterDashboardV2PagePrefetchedDataProps } from 'src/app/pages/starterDashboardV2/pageContext';

import { Layout } from '../layout';

import { StarterDashboardV2ErrorHandler } from './ErrorHandler';
import { ExportHandler } from './ExportHandler';

export const StarterDashboardV2 = withPrefetchedData(
	function StarterDashboardV2({ prefetchedData }: StarterDashboardV2PagePrefetchedDataProps): JSX.Element {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<StarterDashboardV2PageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={StarterDashboardV2ErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<StarterDashboardV2PageNotificationManagerProvider>
					<ExportHandler>
						<Layout />
					</ExportHandler>
				</StarterDashboardV2PageNotificationManagerProvider>
			</StarterDashboardV2PageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
	},
);
